<template>
  <Card no-margin no-padding class="choose-campaign-option">
    <div class="choose-campaign-option__content">
      <div class="choose-campaign-option__header">
        <img
          width="40"
          height="40"
          class="choose-campaign-option__image"
          :src="image"
          :alt="title"
        />
        <h4 class="choose-campaign-option__title">{{ title }}</h4>
      </div>

      <p class="choose-campaign-option__description">{{ description }}</p>

      <ElButton
        type="primary"
        plain
        class="choose-campaign-option__button"
        @click="$emit('select')"
      >
        {{ buttonText || $t('ADVERTISEMENT.CAMPAIGNS.CREATE_CAMPAIGN') }}
      </ElButton>
    </div>
  </Card>
</template>

<script>
import Card from '@@/common/Card';

export default {
  name: 'ChooseCampaignOption',
  components: {
    Card,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: '',
    },
    moreInfoLink: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.choose-campaign-option {
  border-radius: 5px;
  width: 100%;
  border: 1px solid transparent;
  box-shadow: 0 2px 5px 0 #0003;

  &__header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__title {
    font-size: 0.9rem;
    font-weight: bold;
    color: $midnight-blue;
    margin: 0;
  }

  &__description {
    font-size: 0.8rem;
    color: $lb-dark-gray;
    margin-bottom: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    padding: 1.5 * $global-padding;
  }

  &__image {
    width: 40px;
    height: 40px;
  }

  &__button {
    margin-top: $global-margin;
  }

  &:hover {
    border-color: $green-pear;

    i {
      color: $green-pear;
    }
  }
}
</style>
